module.exports = __webpack_public_path__ + "img/serge.4b639ccc.png";